import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Button, Card, Col, Row } from "reactstrap";
import {
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import { DatePicker, Empty, Flex, Spin, Table } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import contractorsApis from "../../api/master/contractors";
import dayjs from "dayjs";
import reportApis from "../../api/reports";
import { useNavigate } from "react-router";
import { FormProvider, useForm } from "react-hook-form";
import FormSelect from "../form-components/SelectComponent";
import FormMultiSelectReport from "../form-components/MultiSelectReportComponent";
import supplierApis from "../../api/master/supplier";
import misc from "../../api/misc/dropDowns";
import FormDatePicker from "../form-components/DatePicker";
import FormInput from "../form-components/InputComponent";
import Export from "../../components/export/Export";
import { formatCurrency } from "../../utils/Utils";
import sitebreakdownMasterApis from "../../api/master/sitebreakdownMaster";
import SearchInput from "../form-components/SearchComponent";
import { SearchOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;

//  This template has site, contractor, supplier, dateRange, customDateRange filters with table pagination

function ReportTemplate2({
  pageTitle,
  moduleKey,
  columns,
  filtersOption,
  previousPath,
  extra,
  pageDescription,
}: {
  pageTitle: string;
  pageDescription?: string;
  moduleKey: string;
  columns: any;
  filtersOption: {
    site?: boolean;
    contractor?: boolean;
    dateRange?: boolean;
    supplier?: boolean;
    aging?: boolean;
    material?: boolean;
    category?: boolean;
    stockAvailability?: boolean;
    date?: boolean;
    classPercentage?: boolean;
    tower?: boolean;
    floor?: boolean;
    flat?: boolean;
    location?: boolean;
    searchable?: boolean;
  };
  previousPath: string;
  extra?: any;
}) {
  const [loading, setLoading] = useState(
    moduleKey === "supplierLedgerReport"
      ? false
      : !filtersOption?.classPercentage
  );
  const navigate = useNavigate();
  const { data: currentUser } = useSelector(
    (state: RootState) => state.currentUser
  );
  const [sm, setSm] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const [siteOptions, setSiteOptions] = useState<any>([]);
  const [materialOptions, setMaterialOptions] = useState<any>([]);
  const [categoryOptions, setCategoryOptions] = useState<any>([]);
  const [supplierOptions, setSupplierOptions] = useState<any>([]);
  const stockAvailabilityOptions = [
    {
      label: "= Zero",
      value: "nil",
    },
    {
      label: "> Zero",
      value: "notNil",
    },
  ];
  const [contractorOptions, setContractorOptions] = useState<any>([]);
  const [towerOptions, setTowerOptions] = useState<any>([]);
  const [floorOptions, setFloorOptions] = useState<any>([]);
  const [flatOptions, setFlatOptions] = useState<any>([]);
  const [locationOptions, setLocationOptions] = useState<any>([]);
  const [customDateRange, setCustomDateRange] = useState<any>();
  const [dataSource, setDataSource] = useState([]);
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentAvailability, setCurrentAvailability] = useState<any>();
  const [pagination, setPagination] = useState<any>({
    current: 1,
    pageSize: 10,
    defaultCurrent: 1,
    defaultPageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "30", "40", "50"],
  });
  const [classPercentageInitialValue, setClassPercentageInitialValue] =
    useState<any>(null);

  const methods = useForm({
    mode: "onChange",
  });

  const { watch, setValue } = methods;

  const supplier = watch("supplier");
  const stockAvailability = watch("stockAvailability");
  const site = watch("site");
  const contractor = watch("contractor");
  const tower = watch("tower");
  const floor = watch("floor");
  const flat = watch("flat");
  const location = watch("location");
  const dateRange = watch("dateRange");
  const date = watch("date");
  const aging = watch("aging");
  const material = watch("material");
  const category = watch("category");
  const classPercentage = watch("classPercentage");
  const intervalOfDays = watch("intervalOfDays");
  const classPercentageA = watch("classPercentageA");
  const classPercentageB = watch("classPercentageB");
  const classPercentageC = watch("classPercentageC");

  const fetchContractorList = async (siteId: any) => {
    try {
      if (
        !filtersOption.contractor ||
        !siteId ||
        siteId?.toString()?.includes(",")
      ) {
        setValue("contractor", "");
        setContractorOptions([]);
        return;
      }
      const { data, status } = await contractorsApis.fetchContractorBySiteId({
        id: siteId + "",
      });
      if (status) {
        let allContractors: any = [];
        let _contractorOptions: any = [];
        data.forEach((item: any) => {
          allContractors.push(item?.contractorID?.toString());
          _contractorOptions.push({
            label: item?.companyName,
            value: item?.contractorID?.toString(),
          });
        });

        setValue("contractor", null);
        if (_contractorOptions.length > 1) {
          _contractorOptions = [
            {
              label: "ALL",
              value: allContractors?.join(","),
            },
            ..._contractorOptions,
          ];
        }
        setContractorOptions(_contractorOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTowerList = async (siteId: any) => {
    try {
      if (
        !filtersOption.tower ||
        !siteId ||
        siteId?.toString()?.includes(",")
      ) {
        setValue("tower", []);
        setValue("floor", []);
        setValue("flat", []);
        setTowerOptions([]);
        setFloorOptions([]);
        setFlatOptions([]);
        return;
      }
      const { data, status } = await sitebreakdownMasterApis.fetchUnitsBySiteId({
        siteId: siteId + "",
      });
      if (status) {
        let _towerOptions: any = [];
        data.forEach((item: any) => {
          _towerOptions.push({
            label: item?.unitName,
            value: item?.id?.toString(),
          });
        });

        setValue("tower", []);
        setValue("floor", []);
        setValue("flat", []);
        setFloorOptions([]);
        setFlatOptions([]);
        setTowerOptions(_towerOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFloorList = async (siteId: any, towerIds: any) => {
    try {
      if (
        !filtersOption.floor ||
        !siteId ||
        !towerIds ||
        siteId?.toString()?.includes(",") ||
        (Array.isArray(towerIds) && towerIds.length === 0)
      ) {
        setValue("floor", []);
        setValue("flat", []);
        setFloorOptions([]);
        setFlatOptions([]);
        return;
      }
      // Fetch floors for all selected towers
      const towerIdsArray = Array.isArray(towerIds) ? towerIds : [towerIds];
      const allFloorOptions: any = [];
      const uniqueFloors = new Set<string>();

      for (const towerId of towerIdsArray) {
        const { data, status } = await sitebreakdownMasterApis.fetchFloorNumbersByUnitId({
          siteId: siteId + "",
          unitId: towerId + "",
        });
        if (status) {
          data.forEach((item: any) => {
            const floorNo = item?.floorNo?.toString();
            if (!uniqueFloors.has(floorNo)) {
              uniqueFloors.add(floorNo);
              allFloorOptions.push({
                label: floorNo,
                value: floorNo,
              });
            }
          });
        }
      }

      setValue("floor", []);
      setValue("flat", []);
      setFlatOptions([]);
      setFloorOptions(allFloorOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFlatList = async (siteId: any, towerIds: any, floorNos: any) => {
    try {
      if (
        !filtersOption.flat ||
        !siteId ||
        !towerIds ||
        !floorNos ||
        siteId?.toString()?.includes(",") ||
        (Array.isArray(towerIds) && towerIds.length === 0) ||
        (Array.isArray(floorNos) && floorNos.length === 0)
      ) {
        setValue("flat", []);
        setFlatOptions([]);
        return;
      }
      // Fetch flats for all selected towers and floors
      const towerIdsArray = Array.isArray(towerIds) ? towerIds : [towerIds];
      const floorNosArray = Array.isArray(floorNos) ? floorNos : [floorNos];
      const allFlatOptions: any = [];
      const uniqueFlats = new Set<string>();

      for (const towerId of towerIdsArray) {
        for (const floorNo of floorNosArray) {
          const { data, status } = await sitebreakdownMasterApis.fetchSubUnitsByUnitId({
            siteId: siteId + "",
            unitId: towerId + "",
            floorNo: floorNo + "",
          });
          if (status) {
            data.forEach((item: any) => {
              const flatId = item?.id?.toString();
              if (!uniqueFlats.has(flatId)) {
                uniqueFlats.add(flatId);
                allFlatOptions.push({
                  label: item?.subUnitName,
                  value: flatId,
                });
              }
            });
          }
        }
      }

      setValue("flat", []);
      setFlatOptions(allFlatOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchLocationList = async (siteId: any) => {
    try {
      if (
        !filtersOption.location ||
        !siteId ||
        siteId?.toString()?.includes(",")
      ) {
        setValue("location", []);
        setLocationOptions([]);
        return;
      }
      const { data, status } = await sitebreakdownMasterApis.fetchLocationsBySiteId({
        siteId: siteId + "",
      });
      if (status) {
        let _locationOptions: any = [];
        data.forEach((item: any) => {
          _locationOptions.push({
            label: item?.locationName || item?.name,
            value: item?.id?.toString(),
          });
        });

        setValue("location", []);
        setLocationOptions(_locationOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async (params: any) => {
    // console.log(params,'params');
    const { siteId: site, categoryId: category, materialId: material, supplierId: supplier } = params;
    try {
      let response: any = {};
      switch (moduleKey) {
        case "InventorySummaryReport":
          response = await reportApis.getInventorySummaryReport({
            page: params.page,
            pageSize: params.pageSize,
            siteIds: site,
            endDate: date !== null ? dayjs(date).format("YYYY-MM-DD") : null,
            stockAvailability: stockAvailability,
            locationIds: params.locationId,
          });
          break;

        case "InventoryAgingReport":
          response = await reportApis.fetchInventoryAgingMaterials({
            page: params.page,
            sortOrder: "ASC",
            pageSize: params.pageSize,
            siteIds: site,
            endDate: date !== null ? dayjs(date).format("YYYY-MM-DD") : null,
            materialIds: material,
            intervalCount: params.interval,
            daysGap: params.intervalDays,
            locationIds: params.locationId,
          });

          break;

        case "InventoryValueReport":
          response = await reportApis.fetchInventoryValueReport({
            page: params.page,
            pageSize: params.pageSize,
            siteIds: site,
            endDate: date !== null ? dayjs(date).format("YYYY-MM-DD") : null,
            locationIds: params.locationId,
            categoryIds: category,
            supplierIds: supplier,
          });
          break;

        case "materialsIssuedToSite":
          const handoverListParams: any = {
            page: params.page,
            pageSize: params.pageSize,
            siteIds: site,
          };
          
          if (params.contractorId) {
            handoverListParams.contractorIds = Array.isArray(params.contractorId) 
              ? params.contractorId.join(",") 
              : params.contractorId;
          }
          
          if (params.towerId && (Array.isArray(params.towerId) ? params.towerId.length > 0 : params.towerId)) {
            handoverListParams.unitNameIds = Array.isArray(params.towerId) 
              ? params.towerId.join(",") 
              : params.towerId;
          }
          
          if (params.floorNo && (Array.isArray(params.floorNo) ? params.floorNo.length > 0 : params.floorNo)) {
            handoverListParams.floorNo = Array.isArray(params.floorNo) 
              ? params.floorNo.join(",") 
              : params.floorNo;
          }
          
          if (params.flatId && (Array.isArray(params.flatId) ? params.flatId.length > 0 : params.flatId)) {
            handoverListParams.subUnitNameIds = Array.isArray(params.flatId) 
              ? params.flatId.join(",") 
              : params.flatId;
          }
          
          if (params.locationId && (Array.isArray(params.locationId) ? params.locationId.length > 0 : params.locationId)) {
            handoverListParams.locationNameIds = Array.isArray(params.locationId) 
              ? params.locationId.join(",") 
              : params.locationId;
          }
          
          response = await reportApis.fetchMaterialIssueToSite(handoverListParams);
          break;
        case "inventoryMaterialUtilizationReportList":
          const utilizationListParams: any = {
            page: params.page,
            pageSize: params.pageSize,
            siteIds: site,
          };
          
          if (material) {
            utilizationListParams.materialIds = Array.isArray(material) 
              ? material.join(",") 
              : material;
          }
          
          if (params.towerId && (Array.isArray(params.towerId) ? params.towerId.length > 0 : params.towerId)) {
            utilizationListParams.unitNameIds = Array.isArray(params.towerId) 
              ? params.towerId.join(",") 
              : params.towerId;
          }
          
          if (params.floorNo && (Array.isArray(params.floorNo) ? params.floorNo.length > 0 : params.floorNo)) {
            utilizationListParams.floorNo = Array.isArray(params.floorNo) 
              ? params.floorNo.join(",") 
              : params.floorNo;
          }
          
          if (params.flatId && (Array.isArray(params.flatId) ? params.flatId.length > 0 : params.flatId)) {
            utilizationListParams.subUnitNameIds = Array.isArray(params.flatId) 
              ? params.flatId.join(",") 
              : params.flatId;
          }
          
          if (params.locationId && (Array.isArray(params.locationId) ? params.locationId.length > 0 : params.locationId)) {
            utilizationListParams.locationNameIds = Array.isArray(params.locationId) 
              ? params.locationId.join(",") 
              : params.locationId;
          }
          
          response = await reportApis.fetchInventoryMaterialUtilization(utilizationListParams);
          break;
        case "InventoryValueDetailReport":
          const inventoryValueDetailData: any = {
            inventoryId: Number(extra?.id),
            historyId:
              extra?.historyId == "null" ? null : Number(extra?.historyId),
          };
          if (params.supplierId) {
            inventoryValueDetailData.supplierIds = params.supplierId;
          }
          if (params.startDate) {
            inventoryValueDetailData.startDate = params.startDate;
          }
          if (params.endDate) {
            inventoryValueDetailData.endDate = params.endDate;
          }
          response = await reportApis.fetchInventoryValueInvoiceReport(
            inventoryValueDetailData,
            {
              page: params.page,
              pageSize: params.pageSize,
            }
          );
          break;

        case "committedStockReport":
          response = await reportApis.fetchCommittedStockReport(
            {
              inventoryId: Number(extra?.id),
              historyId:
                extra?.historyId == "null" ? null : Number(extra?.historyId),
            },
            { page: params.page, pageSize: params.pageSize }
          );
          break;

        case "ABCClassification":
          response = await reportApis.fetchMaterialAbcClassificationList({
            // page: params.page,
            // pageSize: params.pageSize,
            siteIds: site,
            startDate: params.startDate,
            endDate: params.endDate,
            A: classPercentageA,
            B: classPercentageB,
            C: classPercentageC,
            locationIds: params.locationId,
          });
          break;

        case "MaterialFlowByContractorReport":
          response = await reportApis.fetchMaterialFlowSummaryByContractor({
            page: params.page,
            pageSize: params.pageSize,
            sortOrder: "ASC",
            siteIds: site,
            categoryIds: category,
            contractorIds: params.contractorId,
            endDate: date !== null ? dayjs(date).format("YYYY-MM-DD") : null,
            locationIds: params.locationId,
          });
          break;

        case "InventoryTrackReport":
          response = await reportApis.fetchInventoryTrackReport({
            page: params.page,
            pageSize: params.pageSize,
            endDate: date !== null ? dayjs(date).format("YYYY-MM-DD") : null,
            categoryId: category,
            materialId: material,
            siteId: site,
            locationId: Array.isArray(params.locationId) && params.locationId.length > 0 
              ? params.locationId[0] 
              : params.locationId,
          });
          break;

        case "/material-tracking-report-list":
          response = await reportApis.fetchMaterialTrackingReportList({
            page: params.page,
            pageSize: params.pageSize,
            siteId: site,
            startDate: params.startDate,
            endDate: params.endDate,
            materialIds: material,
            materialId: material,
            categoryId: category,
            locationIds: params.locationId,
          });
          break;
        case "/material-consumption-report-list":
          response = await reportApis.fetchMaterialConsumptionReportList({
            page: params.page,
            pageSize: params.pageSize,
            siteId: site,
            // startDate: params.startDate,
            // endDate: params.endDate,
            materialId: material,
            categoryId: category,
            locationIds: params.locationId,
          });
          break;
        case "/material-request-summary-list":
          const materialRequestParams: any = {
            page: params.page,
            pageSize: params.pageSize,
            siteId: site,
            // startDate: params.startDate,
            // endDate: params.endDate,
            materialId: material,
            categoryId: category,
          };
          if (params.contractorId) {
            materialRequestParams.contractorId = Array.isArray(params.contractorId) 
              ? params.contractorId.join(",") 
              : params.contractorId;
          }
          if (params.towerId && (Array.isArray(params.towerId) ? params.towerId.length > 0 : params.towerId)) {
            materialRequestParams.siteStructureUnitId = Array.isArray(params.towerId) 
              ? params.towerId.join(",") 
              : params.towerId.toString();
          }
          if (params.floorNo && (Array.isArray(params.floorNo) ? params.floorNo.length > 0 : params.floorNo)) {
            materialRequestParams.floor = Array.isArray(params.floorNo) 
              ? params.floorNo.join(",") 
              : params.floorNo.toString();
          }
          if (params.flatId && (Array.isArray(params.flatId) ? params.flatId.length > 0 : params.flatId)) {
            materialRequestParams.siteStructureSubUnitId = Array.isArray(params.flatId) 
              ? params.flatId.join(",") 
              : params.flatId.toString();
          }
          if (params.locationId && (Array.isArray(params.locationId) ? params.locationId.length > 0 : params.locationId)) {
            materialRequestParams.locationId = Array.isArray(params.locationId) 
              ? params.locationId.join(",") 
              : params.locationId.toString();
          }
          response = await reportApis.fetchMaterialRequestSummaryList(materialRequestParams);
          break;
        case "/material-issue-summary-list":
          const materialIssueParams: any = {
            page: params.page,
            pageSize: params.pageSize,
            siteId: site,
            // startDate: params.startDate,
            // endDate: params.endDate,
            materialId: material,
            categoryId: category,
          };
          if (params.contractorId) {
            materialIssueParams.contractorId = Array.isArray(params.contractorId) 
              ? params.contractorId.join(",") 
              : params.contractorId;
          }
          if (params.towerId && (Array.isArray(params.towerId) ? params.towerId.length > 0 : params.towerId)) {
            materialIssueParams.siteStructureUnitId = Array.isArray(params.towerId) 
              ? params.towerId.join(",") 
              : params.towerId.toString();
          }
          if (params.floorNo && (Array.isArray(params.floorNo) ? params.floorNo.length > 0 : params.floorNo)) {
            materialIssueParams.floor = Array.isArray(params.floorNo) 
              ? params.floorNo.join(",") 
              : params.floorNo.toString();
          }
          if (params.flatId && (Array.isArray(params.flatId) ? params.flatId.length > 0 : params.flatId)) {
            materialIssueParams.siteStructureSubUnitId = Array.isArray(params.flatId) 
              ? params.flatId.join(",") 
              : params.flatId.toString();
          }
          if (params.locationId && (Array.isArray(params.locationId) ? params.locationId.length > 0 : params.locationId)) {
            materialIssueParams.locationId = Array.isArray(params.locationId) 
              ? params.locationId.join(",") 
              : params.locationId.toString();
          }
          response = await reportApis.fetchMaterialIssueSummaryList(materialIssueParams);
          break;
        case "/material-utilized-summary-list":
          const materialUtilizedParams: any = {
            page: params.page,
            pageSize: params.pageSize,
            siteId: site,
            // startDate: params.startDate,
            // endDate: params.endDate,
            materialId: material,
            categoryId: category,
          };
          if (params.contractorId) {
            materialUtilizedParams.contractorId = Array.isArray(params.contractorId) 
              ? params.contractorId.join(",") 
              : params.contractorId;
          }
          if (params.towerId && (Array.isArray(params.towerId) ? params.towerId.length > 0 : params.towerId)) {
            materialUtilizedParams.siteStructureUnitId = Array.isArray(params.towerId) 
              ? params.towerId.join(",") 
              : params.towerId.toString();
          }
          if (params.floorNo && (Array.isArray(params.floorNo) ? params.floorNo.length > 0 : params.floorNo)) {
            materialUtilizedParams.floor = Array.isArray(params.floorNo) 
              ? params.floorNo.join(",") 
              : params.floorNo.toString();
          }
          if (params.flatId && (Array.isArray(params.flatId) ? params.flatId.length > 0 : params.flatId)) {
            materialUtilizedParams.siteStructureSubUnitId = Array.isArray(params.flatId) 
              ? params.flatId.join(",") 
              : params.flatId.toString();
          }
          if (params.locationId && (Array.isArray(params.locationId) ? params.locationId.length > 0 : params.locationId)) {
            materialUtilizedParams.locationId = Array.isArray(params.locationId) 
              ? params.locationId.join(",") 
              : params.locationId.toString();
          }
          response = await reportApis.fetchMaterialUtilizedSummaryList(materialUtilizedParams);
          break;
        case "/material-damage-summary-list":
          const materialDamageParams: any = {
            page: params.page,
            pageSize: params.pageSize,
            siteId: site,
            // startDate: params.startDate,
            // endDate: params.endDate,
            materialId: material,
            categoryId: category,
          };
          if (params.contractorId) {
            materialDamageParams.contractorId = Array.isArray(params.contractorId) 
              ? params.contractorId.join(",") 
              : params.contractorId;
          }
          if (params.towerId && (Array.isArray(params.towerId) ? params.towerId.length > 0 : params.towerId)) {
            materialDamageParams.siteStructureUnitId = Array.isArray(params.towerId) 
              ? params.towerId.join(",") 
              : params.towerId.toString();
          }
          if (params.floorNo && (Array.isArray(params.floorNo) ? params.floorNo.length > 0 : params.floorNo)) {
            materialDamageParams.floor = Array.isArray(params.floorNo) 
              ? params.floorNo.join(",") 
              : params.floorNo.toString();
          }
          if (params.flatId && (Array.isArray(params.flatId) ? params.flatId.length > 0 : params.flatId)) {
            materialDamageParams.siteStructureSubUnitId = Array.isArray(params.flatId) 
              ? params.flatId.join(",") 
              : params.flatId.toString();
          }
          if (params.locationId && (Array.isArray(params.locationId) ? params.locationId.length > 0 : params.locationId)) {
            materialDamageParams.locationId = Array.isArray(params.locationId) 
              ? params.locationId.join(",") 
              : params.locationId.toString();
          }
          response = await reportApis.fetchMaterialDamageSummaryList(materialDamageParams);
          break;
        case "/material-summary-list":
          const materialSummaryParams: any = {
            page: params.page,
            pageSize: params.pageSize,
            siteId: site,
            // startDate: params.startDate,
            // endDate: params.endDate,
            materialId: material,
            categoryId: category,
            locationIds: params.locationId,
          };
          if (params.contractorId) {
            materialSummaryParams.contractorId = Array.isArray(params.contractorId) 
              ? params.contractorId.join(",") 
              : params.contractorId;
          }
          response = await reportApis.fetchMaterialSummaryList(materialSummaryParams);
          break;
        case "MaterialMovementSummaryDetailReport":
          response = await reportApis.fetchMaterialSummaryDetailList({
            page: params.page,
            pageSize: params.pageSize,
            siteId: extra?.customData?.siteId,
            // startDate: params.startDate,
            // endDate: params.endDate,
            materialId: extra?.customData?.materialId,
            categoryId: extra?.customData?.categoryId,
          });
          break;
        case "materialUtilizationSummaryDetailReport":
          response = await reportApis.fetchAvgMaterialUtilizedBreakup({
            page: params.page,
            pageSize: params.pageSize,
            siteId: extra?.customData?.siteId,
            // startDate: params.startDate,
            // endDate: params.endDate,
            materialId: extra?.customData?.materialId,
            categoryId: extra?.customData?.categoryId,
          });
          break;
        case "supplierLedgerReport":
          response = await reportApis.fetchSupplierLedgerReport({
            page: params.page,
            pageSize: params.pageSize,
            supplierIds: supplier,
          });
          break;
        default:
          alert("Invalid Module Key: " + moduleKey);
      }
      const { response: _response, status }: any = response;
      if (status) {
        setDataSource(_response?.data || _response);
        if (moduleKey === "InventoryTrackReport") {
          setCurrentAvailability(_response?.closingStock);
        }
        setPagination((pre: any) => ({
          ...pre,
          current: _response?.pagination?.currentPage,
          pageSize: _response?.pagination?.pageSize,
          total: Number(_response?.pagination?.totalItems),
        }));
        // Initialize filteredDataSource when data is loaded
        if (filtersOption?.searchable) {
          setFilteredDataSource(_response?.data || _response);
        }
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const convertToDates = (dateType: string) => {
    try {
      switch (dateType) {
        case "Month to Date":
          return {
            from: dayjs().startOf("month").format("YYYY-MM-DD"),
            to: dayjs().format("YYYY-MM-DD"),
          };
        case "Quarter to Date":
          return {
            from: dayjs()
              .subtract(3, "month")
              .startOf("month")
              .format("YYYY-MM-DD"),
            to: dayjs().format("YYYY-MM-DD"),
          };
        case "Year to Date":
          return {
            from: dayjs().startOf("year").format("YYYY-MM-DD"),
            to: dayjs().format("YYYY-MM-DD"),
          };
        default:
          if (!customDateRange)
            return {
              from: dayjs()?.format("YYYY-MM-DD"),
              to: dayjs()?.format("YYYY-MM-DD"),
            };
          return {
            from: dayjs(customDateRange[0]).format("YYYY-MM-DD"),
            to: dayjs(customDateRange[1]).format("YYYY-MM-DD"),
          };
      }
    } catch (error) {
      return {
        from: dayjs()?.format("YYYY-MM-DD"),
        to: dayjs()?.format("YYYY-MM-DD"),
      };
    }
  };
  const formatParamsForFetchData = ({
    supplier,
    site,
    contractor,
    tower,
    floor,
    flat,
    location,
    dateRange,
    customDateRange,
    date,
    pagination,
    aging,
    material,
    category,
    stockAvailability,
    classPercentage,
    intervalOfDays,
    classPercentageA,
    classPercentageB,
    classPercentageC,
  }: any) => {
    if (site) {
      if (
        (dateRange == "Custom Date" && !customDateRange) ||
        // (filtersOption?.contractor && !contractor) ||                       // commented for now
        (filtersOption?.supplier && !supplier) ||
        (filtersOption?.material &&
          !material &&
          moduleKey == "InventoryTrackReport") ||
        (filtersOption?.category &&
          !category &&
          moduleKey == "InventoryTrackReport") ||
        (filtersOption?.classPercentage && !classPercentageA) ||
        (filtersOption?.classPercentage && !classPercentageB) ||
        (filtersOption?.classPercentage && !classPercentageC) ||
        (filtersOption?.classPercentage &&
          Number(classPercentageA) +
            Number(classPercentageB) +
            Number(classPercentageC) !=
            100) ||
        (filtersOption?.site && !site) ||
        (filtersOption?.aging && !aging) ||
        (filtersOption?.aging && !intervalOfDays)
      ) {
        // conditions to return if any of the above condition fails
        setClassPercentageInitialValue(null);
        return;
      }
      if (!classPercentageInitialValue) setClassPercentageInitialValue("... ");
      setLoading(true);
      const { from, to } = convertToDates(dateRange);
      let paramsObj: any = {};
      if (filtersOption?.site) paramsObj.siteId = site + "";
      if (filtersOption?.supplier) paramsObj.supplierId = supplier;
      if (filtersOption?.material) paramsObj.materialId = material;
      if (filtersOption?.category) paramsObj.categoryId = category;
      if (filtersOption?.stockAvailability)
        paramsObj.stockAvailability = stockAvailability;
      if (filtersOption?.contractor) paramsObj.contractorId = contractor;
      if (filtersOption?.tower) paramsObj.towerId = Array.isArray(tower) ? tower : (tower ? [tower] : null);
      if (filtersOption?.floor) paramsObj.floorNo = Array.isArray(floor) ? floor : (floor ? [floor] : null);
      if (filtersOption?.flat) paramsObj.flatId = Array.isArray(flat) ? flat : (flat ? [flat] : null);
      if (filtersOption?.location) paramsObj.locationId = Array.isArray(location) ? location : (location ? [location] : null);
      if (filtersOption?.aging) paramsObj.interval = aging;
      if (filtersOption?.aging) paramsObj.intervalDays = intervalOfDays;
      fetchData({
        ...paramsObj,
        startDate: from,
        endDate: to,
        page: pagination.current,
        pageSize: pagination.pageSize,
      });
    } else if (!filtersOption?.site) {
      setLoading(true);
      const { from, to } = convertToDates(dateRange);
      let paramsObj: any = {
        page: pagination.current,
        pageSize: pagination.pageSize,
      };
      if (filtersOption?.supplier && supplier) {
        paramsObj.supplierId = supplier;
      }
      if (filtersOption?.dateRange && from && to) {
        paramsObj.startDate = from;
        paramsObj.endDate = to;
      }
      fetchData(paramsObj);
    }
  };
  useEffect(() => {
    // For supplier ledger report, only fetch data when supplier is selected
    if (moduleKey === "supplierLedgerReport" && !supplier) {
      return;
    }

    formatParamsForFetchData({
      classPercentageA,
      classPercentageB,
      classPercentageC,
      aging,
      intervalOfDays,
      site,
      supplier,
      material,
      category,
      stockAvailability,
      contractor,
      tower,
      floor,
      flat,
      location,
      dateRange,
      customDateRange,
      date,
      pagination: {
        current: 1,
        pageSize: pagination?.pageSize,
      },
    });
  }, [
    site,
    supplier,
    stockAvailability,
    // contractor, // removed to prevent duplicate calls when contractor changes
    dateRange,
    customDateRange,
    date,
    aging,
    material,
    category,
    classPercentage,
    intervalOfDays,
    classPercentageA,
    classPercentageB,
    classPercentageC,
    tower,
    floor,
    flat,
    location,
  ]);
  // }, [site, supplier, contractor, dateRange, customDateRange,aging,intervalOfDays]);

  useEffect(() => {
    setValue("material", "");
    if (category) {
      fetchMaterialFilter(category);
    }
  }, [category]);

  useEffect(() => {
    if (site) {
      fetchContractorList("" + site);
      if (filtersOption?.tower) {
        fetchTowerList("" + site);
      }
      if (filtersOption?.location) {
        fetchLocationList("" + site);
      }
    }
  }, [site]);

  useEffect(() => {
    if (site && tower && filtersOption?.floor) {
      const towerIds = Array.isArray(tower) ? tower : [tower];
      if (towerIds.length > 0) {
        fetchFloorList("" + site, towerIds);
      }
    } else if (!tower || (Array.isArray(tower) && tower.length === 0)) {
      setValue("floor", []);
      setValue("flat", []);
      setFloorOptions([]);
      setFlatOptions([]);
    }
  }, [tower, site]);

  useEffect(() => {
    if (site && tower && floor && filtersOption?.flat) {
      const towerIds = Array.isArray(tower) ? tower : [tower];
      const floorNos = Array.isArray(floor) ? floor : [floor];
      if (towerIds.length > 0 && floorNos.length > 0) {
        fetchFlatList("" + site, towerIds, floorNos);
      }
    } else if (!floor || (Array.isArray(floor) && floor.length === 0)) {
      setValue("flat", []);
      setFlatOptions([]);
    }
  }, [floor, tower, site]);

  // Separate useEffect for contractor changes
  useEffect(() => {
    if (contractor) {
      formatParamsForFetchData({
        classPercentageA,
        classPercentageB,
        classPercentageC,
        aging,
        intervalOfDays,
        site,
        supplier,
        material,
        category,
        stockAvailability,
        contractor,
        tower,
        floor,
        flat,
        location,
        dateRange,
        customDateRange,
        date,
        pagination: {
          current: 1,
          pageSize: pagination?.pageSize,
        },
      });
    }
  }, [contractor]);
  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth >= 990) {
      setSm(false);
    }
  };

  const fetchSupplierFilter = async () => {
    try {
      if (!filtersOption.supplier) return;

      // If supplierOptions are provided via extra prop, use them directly
      if (extra?.supplierOptions && extra.supplierOptions.length > 0) {
        setSupplierOptions(extra.supplierOptions);
        return;
      }

      // Otherwise, fetch from the default API
      const { data, status } = await supplierApis.fetchSupplierFilter();
      if (status) {
        let _supplierOptions: any = [];
        let allSuppliers: any = [];
        data.forEach((item: any) => {
          allSuppliers.push(item?.supplierOrgID?.toString());
          _supplierOptions.push({
            label: item?.supplierName,
            value: item?.supplierOrgID?.toString(),
          });
        });

        // Don't set default value for supplier ledger report
        if (moduleKey !== "supplierLedgerReport") {
          setValue("supplier", allSuppliers?.join(","));
        }

        if (_supplierOptions.length > 1) {
          _supplierOptions = [
            {
              label: "ALL",
              value: allSuppliers?.join(","),
            },
            ..._supplierOptions,
          ];
        }
        setSupplierOptions(_supplierOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMaterialFilter = async (categoryId: any) => {
    try {
      if (!filtersOption.material || !categoryId) return;
      const { data, status } = await misc.fetchProductByCategoryId(categoryId);
      if (status) {
        let _materialOptions: any = [];
        let allMaterial: any = [];
        data.forEach((item: any) => {
          allMaterial.push(item?.materialID?.toString());
          _materialOptions.push({
            label: item?.productName,
            value: item?.materialID?.toString(),
          });
        });
        // setValue("material", allMaterial?.join(","));
        if (_materialOptions.length > 1) {
          _materialOptions = [
            // {
            //   label: "ALL",
            //   value: allMaterial?.join(","),
            // },
            ..._materialOptions,
          ];
        }
        setMaterialOptions(_materialOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategoryFilter = async () => {
    try {
      if (!filtersOption.category) return;
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        let _categoryOptions: any = [];
        let allCategory: any = [];
        data.forEach((item: any) => {
          allCategory.push(item?.id?.toString());
          _categoryOptions.push({
            label: item?.category,
            value: item?.id?.toString(),
          });
        });
        // setValue("category", allCategory?.join(","));
        if (_categoryOptions.length > 1) {
          _categoryOptions = [
            // {
            //   label: "ALL",
            //   value: allCategory?.join(","),
            // },
            ..._categoryOptions,
          ];
        }
        setCategoryOptions(_categoryOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Search filtering effect
  useEffect(() => {
    if (!filtersOption?.searchable) {
      return;
    }

    if (!searchQuery || searchQuery.trim() === "") {
      setFilteredDataSource(dataSource);
      return;
    }

    const query = searchQuery.toLowerCase().trim();
    const filtered = dataSource.filter((item: any) => {
      // Search in site name
      if (
        item?.siteName &&
        item.siteName.toLowerCase().includes(query)
      ) {
        return true;
      }
      // Search in category name
      if (
        item?.categoryName &&
        item.categoryName.toLowerCase().includes(query)
      ) {
        return true;
      }
      // Search in material name
      if (
        item?.materialName &&
        item.materialName.toLowerCase().includes(query)
      ) {
        return true;
      }
      // Search in UOM
      if (
        item?.primaryUomName &&
        item.primaryUomName.toLowerCase().includes(query)
      ) {
        return true;
      }
      // Search in material ID if available
      if (
        item?.materialId &&
        item.materialId.toString().toLowerCase().includes(query)
      ) {
        return true;
      }
      return false;
    });

    setFilteredDataSource(filtered);
    // Reset pagination to first page when filtering
    setPagination((pre: any) => ({
      ...pre,
      current: 1,
      total: filtered.length,
    }));
  }, [searchQuery, dataSource, filtersOption?.searchable]);

  useEffect(() => {
    viewChange();
    fetchSupplierFilter();
    // fetchMaterialFilter();
    fetchCategoryFilter();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  // Update supplier options when extra.supplierOptions changes
  useEffect(() => {
    if (extra?.supplierOptions && extra.supplierOptions.length > 0) {
      setSupplierOptions(extra.supplierOptions);
    }
  }, [extra?.supplierOptions]);
  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility } = currentUser;
      if (siteAccessibility && filtersOption?.site) {
        const allSites: any = [];
        let _siteOptions: any = [];
        siteAccessibility?.forEach((item: any) => {
          allSites.push(item.siteID);
          _siteOptions.push({ label: item.siteName, value: item.siteID });
        });
        if (moduleKey !== "InventoryTrackReport") {
          setValue("site", allSites?.join(","));
          // setSite(allSites.join(","));
          // formatParamsForFetchData call removed - it will be triggered by the main useEffect when site changes
        }

        if (_siteOptions?.length > 1) {
          if (moduleKey == "InventoryTrackReport") {
            _siteOptions = [
              // {
              //   label: "ALL",
              //   value: allSites?.join(","),
              // },
              ..._siteOptions,
            ];
          } else {
            _siteOptions = [
              {
                label: "ALL",
                value: allSites?.join(","),
              },
              ..._siteOptions,
            ];
          }
        }
        setSiteOptions(_siteOptions);
      }
      if (filtersOption?.dateRange) {
        setValue("dateRange", "Quarter to Date");
      }
      if (filtersOption?.aging) {
        setValue("aging", 3);
        setValue("intervalOfDays", 15);
      }
    }
  }, [currentUser]);

  const getAgingIntervalColumns = () => {
    if (aging == 1) {
      return [
        {
          title: ">= 1 days",
          dataIndex: ">= 1 days",
          key: ">= 1 days",
          // width: 100,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {text}
                {/* {formatCurrency(text?.toString(), record?.currencyCode)} */}
              </span>
            </div>
          ),
        },
        // {
        //   title: ">= 1 Value",
        //   dataIndex: ">= 1 value",
        //   key: ">= 1 value",
        //   render: (text: any, record: any) => (
        //     <div style={{ textAlign: "right" }}>
        //       <span>{text}</span>
        //     </div>
        //   ),
        // },
      ];
    } else {
      let newColumns: any = [];
      let i = 0,
        intervalCount = 0;
      for (i = 0; i < aging - 1; i++) {
        newColumns.push({
          title: `${intervalCount + 1}-${intervalCount + intervalOfDays} days`,
          dataIndex: `${intervalCount + 1}-${
            intervalCount + intervalOfDays
          } days`,
          key: `${intervalCount + 1}-${intervalCount + intervalOfDays} days`,
          // width: 100,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {text}
                {/* {formatCurrency(text?.toString(), record?.currencyCode)} */}
              </span>
            </div>
          ),
        });
        // newColumns.push({
        //   title: `${intervalCount + 1}-${intervalCount + intervalOfDays} value`,
        //   dataIndex: `${intervalCount + 1}-${intervalCount + intervalOfDays
        //     } value`,
        //   key: `${intervalCount + 1}-${intervalCount + intervalOfDays} value`,
        //   render: (text: any, record: any) => (
        //     <div style={{ textAlign: "right" }}>
        //       <span>{text}</span>
        //     </div>
        //   ),
        // });
        intervalCount += intervalOfDays;
      }
      newColumns.push({
        title: `> ${intervalCount} days`,
        dataIndex: `>${intervalCount} days`,
        key: `>${intervalCount} days`,
        // width: 100,
        render: (text: any, record: any) => (
          <div style={{ textAlign: "right" }}>
            <span>
              {text}
              {/* {formatCurrency(text?.toString(), record?.currencyCode)} */}
            </span>
          </div>
        ),
      });
      // newColumns.push({
      //   title: `> ${intervalCount} value`,
      //   dataIndex: `>= ${intervalCount + 1} value`,
      //   key: `>= ${intervalCount + 1} value`,
      //   render: (text: any, record: any) => (
      //     <div style={{ textAlign: "right" }}>
      //       <span>{text}</span>
      //     </div>
      //   ),
      // });
      return newColumns;
    }
  };

  return (
    <>
      <Head title="View All Reports" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div
              className="card-inner card-inner-lg"
              style={{ minHeight: "75vh" }}
            >
              {sm && (
                <div
                  className="toggle-overlay"
                  onClick={() => setSm(!sm)}
                ></div>
              )}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">
                      <span>{pageTitle}</span>
                    </BlockTitle>
                    <BlockDes className="text-soft">
                      <p>{pageDescription}</p>
                    </BlockDes>
                  </BlockHeadContent>
                  <div className="actions clearfix">
                    <ul
                      className="m-auto d-flex align-items-center justify-content-center p-0"
                      style={{
                        flexDirection: "row-reverse",
                      }}
                    >
                      <li>
                        <Export
                          data={{
                            supplierId: supplier,
                            contractorId: contractor,
                            towerId: tower,
                            floorNo: floor,
                            flatId: flat,
                            locationId: location,
                            dateRange: dateRange && convertToDates(dateRange),
                            customDateRange,
                            aging,
                            intervalOfDays,
                            siteId: site,
                            materialId: material,
                            categoryId: category,
                            page: Number(pagination.current),
                            pageSize: Number(pagination.pageSize),
                          }}
                          moduleKey={moduleKey}
                          reportType="Reports"
                        />
                      </li>
                      <li className="pt-0 pb-0">
                        <Button
                          className="toggle"
                          color="primary"
                          size="sm"
                          onClick={async () => {
                            navigate(previousPath);
                          }}
                        >
                          <Icon name="arrow-left" />
                          <span>Back</span>
                        </Button>
                      </li>
                    </ul>
                  </div>
                </BlockBetween>
              </BlockHead>
              {/* content start here */}
              <div className="d-flex align-items-center flex-wrap mb-2">
                <FormProvider {...methods}>
                  <form className="w-100 d-flex align-items-center justify-content-start">
                    {filtersOption?.site && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginRight: 10 }}
                      >
                        <FormSelect
                          name="site"
                          label="Site Filter"
                          required={true}
                          hideRequiredMark={true}
                          placeholder="Select Site"
                          options={siteOptions}
                        />
                      </div>
                    )}

                    {filtersOption?.stockAvailability && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginRight: 10 }}
                      >
                        <FormSelect
                          name="stockAvailability"
                          required={true}
                          hideRequiredMark={true}
                          label="Stock Availability Filter"
                          placeholder="Select Stock Availability"
                          options={stockAvailabilityOptions}
                        />
                      </div>
                    )}

                    {filtersOption?.contractor && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginRight: 10 }}
                      >
                        <FormSelect
                          name="contractor"
                          required={true}
                          hideRequiredMark={true}
                          label="Contractor Filter"
                          placeholder="Select Contractor"
                          options={contractorOptions}
                        />
                      </div>
                    )}

                    {filtersOption?.tower && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginRight: 10 }}
                      >
                        <FormMultiSelectReport
                          name="tower"
                          required={true}
                          hideRequiredMark={true}
                          label="Tower Filter"
                          placeholder="Select Tower"
                          options={towerOptions}
                        />
                      </div>
                    )}

                    {filtersOption?.floor && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginRight: 10 }}
                      >
                        <FormMultiSelectReport
                          name="floor"
                          required={true}
                          hideRequiredMark={true}
                          label="Floor Filter"
                          placeholder="Select Floor"
                          options={floorOptions}
                        />
                      </div>
                    )}

                    {filtersOption?.flat && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginRight: 10 }}
                      >
                        <FormMultiSelectReport
                          name="flat"
                          required={true}
                          hideRequiredMark={true}
                          label="Flat Filter"
                          placeholder="Select Flat"
                          options={flatOptions}
                        />
                      </div>
                    )}

                    {filtersOption?.location && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginRight: 10 }}
                      >
                        <FormMultiSelectReport
                          name="location"
                          required={true}
                          hideRequiredMark={true}
                          label="Location Filter"
                          placeholder="Select Location"
                          options={locationOptions}
                        />
                      </div>
                    )}

                    {filtersOption?.supplier && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginRight: 10 }}
                      >
                        <FormSelect
                          name="supplier"
                          required={true}
                          hideRequiredMark={true}
                          label="Supplier Filter"
                          placeholder="Select Supplier"
                          options={supplierOptions}
                        />
                      </div>
                    )}

                    {filtersOption?.category && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginRight: 10 }}
                      >
                        <FormSelect
                          name="category"
                          // required={true}
                          hideRequiredMark={true}
                          label="Category Filter"
                          placeholder="Select Category"
                          options={categoryOptions}
                          onChange={(value: any) => {
                            formatParamsForFetchData({
                              classPercentageA,
                              classPercentageB,
                              classPercentageC,
                              aging,
                              intervalOfDays,
                              site,
                              supplier,
                              material,
                              category: value,
                              stockAvailability,
                              contractor,
                              tower,
                              floor,
                              flat,
                              location,
                              dateRange,
                              customDateRange,
                              date,
                              pagination: {
                                current: 1,
                                pageSize: pagination?.pageSize,
                              },
                            });
                          }}
                        />
                      </div>
                    )}

                    {filtersOption?.material && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginRight: 10 }}
                      >
                        <FormSelect
                          name="material"
                          // required={true}
                          hideRequiredMark={true}
                          label="Material Filter"
                          placeholder="Select Material"
                          options={materialOptions}
                        />
                      </div>
                    )}

                    {filtersOption?.date && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginRight: 10 }}
                      >
                        <FormDatePicker
                          name="date"
                          label="Date Filter"
                          // required={true}
                          placeholder="Select Date"
                        />
                      </div>
                    )}

                    {filtersOption?.dateRange && (
                      <div className="w-50 d-flex align-items-end justify-content-start">
                        <div
                          className="mt-1 mb-0 w-40"
                          style={{ marginRight: 10 }}
                        >
                          <FormSelect
                            name="dateRange"
                            required={true}
                            hideRequiredMark={true}
                            // label=""
                            label={"Date Range Filter"}
                            // optionLabel="Date Range"
                            placeholder="Select Date Range"
                            options={[
                              {
                                value: "Month to Date",
                                label: "Month to Date",
                              },
                              {
                                value: "Quarter to Date",
                                label: "Quarter to Date",
                              },
                              { value: "Year to Date", label: "Year to Date" },
                              { value: "Custom Date", label: "Custom Date" },
                            ]}
                          />
                        </div>
                        <div className="mt-1 mb-0 w-50">
                          {dateRange === "Custom Date" && (
                            <RangePicker
                              value={
                                customDateRange
                                  ? [
                                      dayjs(customDateRange[0].toDate()),
                                      dayjs(customDateRange[1].toDate()),
                                    ]
                                  : null
                              }
                              onChange={(dates) => {
                                if (dates && dates[0] && dates[1]) {
                                  setCustomDateRange([dates[0], dates[1]]);
                                } else {
                                  setCustomDateRange(null);
                                }
                              }}
                              style={{ width: "100%" }}
                            />
                          )}
                        </div>
                      </div>
                    )}

                    {filtersOption?.classPercentage && (
                      <div className="mt-1 mb-4" style={{ marginRight: 10 }}>
                        <label
                          className=""
                          style={{
                            fontWeight: "500",
                            color: "#344357",
                            fontSize: "0.875rem",
                          }}
                        >
                          Class Percentage Filter
                        </label>
                        <Row>
                          <Col>
                            <FormInput
                              name="classPercentageA"
                              required={true}
                              label={"A"}
                              placeholder="A"
                              isPercentage={true}
                            />
                          </Col>
                          <Col>
                            <FormInput
                              name="classPercentageB"
                              required={true}
                              label={"B"}
                              placeholder="B"
                              isPercentage={true}
                            />
                          </Col>
                          <Col>
                            <FormInput
                              name="classPercentageC"
                              required={true}
                              label={"C"}
                              placeholder="C"
                              isPercentage={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    )}

                    {filtersOption?.aging && (
                      <>
                        <div
                          className="mt-1 mb-0 w-20"
                          style={{ marginRight: 10 }}
                        >
                          <FormSelect
                            name="aging"
                            required={true}
                            hideRequiredMark={true}
                            label="Aging Filter"
                            placeholder="Select Aging"
                            options={[
                              { label: "1 Interval", value: 1 },
                              ...Array.from({ length: 11 }, (_, i) => ({
                                label: i + 2 + " Intervals",
                                value: i + 2,
                              })),
                            ]}
                          />
                        </div>
                        <div
                          className="mt-1 mb-0 w-20"
                          style={{ marginRight: 10 }}
                        >
                          <FormSelect
                            name="intervalOfDays"
                            required={true}
                            hideRequiredMark={true}
                            label="Interval Of Days Filter"
                            placeholder="Select Interval Of Days"
                            options={[
                              { label: "1 day", value: 1 },
                              ...Array.from({ length: 29 }, (_, i) => ({
                                label: i + 2 + " days",
                                value: i + 2,
                              })),
                            ]}
                          />
                        </div>
                      </>
                    )}

                    {filtersOption?.searchable && (
                      <div
                        className="mt-1 mb-0 w-20"
                        style={{ marginLeft: "auto", paddingTop: "24px" }}
                      >
                        <SearchInput
                          name="search"
                          placeholder="Search..."
                          width="100%"
                          prefixIcon={<SearchOutlined />}
                          onDebouncedSearch={(value: string) => {
                            setSearchQuery(value);
                            setPagination((pre: any) => ({
                              ...pre,
                              current: 1,
                            }));
                          }}
                          debounceDelay={300}
                        />
                      </div>
                    )}
                  </form>
                </FormProvider>
              </div>
              {(filtersOption?.site &&
                !site &&
                moduleKey == "InventoryTrackReport") ||
              (filtersOption?.category &&
                !category &&
                moduleKey == "InventoryTrackReport") ||
              (filtersOption?.material &&
                !material &&
                moduleKey == "InventoryTrackReport") ? (
                <div className="content clearfix">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <Empty
                      description={`Please Select ${[
                        filtersOption?.site && !site ? "Site" : "",
                        filtersOption?.category && !category ? "Category" : "",
                        filtersOption?.material && !material ? "Material" : "",
                      ]
                        ?.filter(Boolean)
                        ?.join(", ")}`}
                    />
                  </div>
                </div>
              ) : (
                <div className="content clearfix">
                  {loading == true ? (
                    <>
                      <Flex align="center" gap="middle" className="pageLoader">
                        <Spin size="large" className="m-auto" />
                      </Flex>
                    </>
                  ) : !classPercentageInitialValue &&
                    filtersOption?.classPercentage ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "200px",
                      }}
                    >
                      <Empty description="Please Enter Class Percentages, that should sum to only 100  ... " />
                    </div>
                  ) : (filtersOption?.searchable
                    ? filteredDataSource
                    : dataSource
                  )?.length > 0 ? (
                    <div
                      style={{
                        width: screenSize - 100 + "px",
                        margin: "0px auto",
                      }}
                    >
                      <Table
                        className="customTable"
                        columns={
                          filtersOption?.aging
                            ? [...columns, ...getAgingIntervalColumns()]
                            : columns
                        }
                        dataSource={
                          filtersOption?.aging
                            ? (filtersOption?.searchable
                                ? filteredDataSource
                                : dataSource
                              )?.map((oldObj: any) => {
                                return {
                                  ...oldObj,
                                  ...oldObj?.agingDetails,
                                };
                              })
                            : filtersOption?.searchable
                            ? filteredDataSource
                            : dataSource
                        }
                        bordered
                        scroll={{ x: extra?.tableScrollX || 1500 }}
                        size="middle"
                        pagination={pagination}
                        onChange={(newPagination, filters, sorter, extra) => {
                          formatParamsForFetchData({
                            aging,
                            intervalOfDays,
                            material,
                            category,
                            classPercentage,
                            site,
                            supplier,
                            contractor,
                            tower,
                            floor,
                            flat,
                            location,
                            dateRange,
                            customDateRange,
                            pagination: {
                              ...pagination,
                              current: newPagination.current,
                              pageSize: newPagination.pageSize,
                            },
                          });
                        }}
                        summary={
                          moduleKey === "InventoryTrackReport"
                            ? () => (
                                <Table.Summary.Row>
                                  <Table.Summary.Cell
                                    index={0}
                                    colSpan={columns.length}
                                  >
                                    <div
                                      style={{
                                        textAlign: "right",
                                        fontWeight: "bold",
                                        marginRight: "8%",
                                      }}
                                    >
                                      Current Availability :{" "}
                                      {currentAvailability}
                                      {dataSource[0]["primaryUomName"]}
                                    </div>
                                  </Table.Summary.Cell>
                                  {/* {
                                  da
                                } */}
                                </Table.Summary.Row>
                              )
                            : undefined
                        }
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "200px",
                      }}
                    >
                      <Empty
                        description={
                          moduleKey === "supplierLedgerReport" && !supplier
                            ? "Please select a supplier to view ledger report"
                            : "No Data Found"
                        }
                      />
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* content end here */}
          </div>
        </Card>
      </Content>
    </>
  );
}

export default ReportTemplate2;
